import { genericConstants, userConstants, authConstants } from '../_constants';
import { userService, genericService } from '../_services';
import { alertActions } from './';

export const userActions = {
  login, whoAmI
};

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password)
      .then(
        user => {
          dispatch(success(user));
          window.location = '/';
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request(user) { return { type: genericConstants.REQUEST_IN_PROGRESS, user } }
  function success(data) { return { type: authConstants.LOGIN_SUCCESS, data } }
  function failure(errors) { return { type: authConstants.LOGIN_FAILURE, errors } }
}

function whoAmI() {
  return dispatch => {
    genericService.apiCall('/api/v1/who-am-i/', 'GET')
      .then(
        data => {
          dispatch(success(data));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };
  function success(data) { return { type: userConstants.WHO_AM_I_LOADED, data } }
  function failure(errors) { return { type: genericConstants.REQUEST_FAILURE, errors } }
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js